import React from "react";
import "./Footer.css";
import { FaFacebookF, FaInstagram, FaWhatsapp, FaPhone } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../assets/aita-logo.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">

        {/* Columna 1: Marca + CTA */}
        <div className="footer-brand">
          <img src={logo} alt="Logo AITA" className="footer-logo-img" />
          <p className="footer-tagline">
            Promociones exclusivas en redes y pedidos rápidos por WhatsApp.
          </p>
          <a
            href="https://wa.me/+528713567094"
            className="footer-cta"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp className="footer-cta-icon" />
            <span>Escríbenos por WhatsApp</span>
          </a>
        </div>

        {/* Columna 2: Navegación */}
        <div className="footer-nav">
          <span className="footer-col-title">Navegación</span>
          <div className="footer-separator" />
          <ul className="footer-nav-list">
            <li><Link to="/" className="footer-nav-link">Inicio</Link></li>
            <li><Link to="/nosotros" className="footer-nav-link">Nosotros</Link></li>
            <li><Link to="/catalogo" className="footer-nav-link">Catálogo</Link></li>
            <li><Link to="/productos" className="footer-nav-link">Productos</Link></li>
            <li><Link to="/asesores" className="footer-nav-link">Asesores</Link></li>
          </ul>
        </div>

        {/* Columna 3: Contacto + Redes */}
        <div className="footer-contact">
          <span className="footer-col-title">Contacto</span>
          <div className="footer-separator" />
          <div className="footer-contact-info">
            <a href="tel:+528713567094" className="footer-contact-item">
              <FaPhone className="footer-contact-icon" />
              <span>+52 871 356 7094</span>
            </a>
          </div>
          <div className="footer-social-row">
            <a
              href="https://www.instagram.com/aitaelectrodomesticos?igsh=MW5iNzFxb2hqbzBrMg=="
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram AITA"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.facebook.com/share/1AnyAdAu3v/?mibextid=wwXIfr"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook AITA"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://wa.me/+528713567094"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp AITA"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>

      </div>

      {/* Franja inferior */}
      <div className="copyright">
        <span>© {currentYear} AITA – Todos los derechos reservados.</span>
        <Link to="/politica-privacidad" className="footer-link">
          Política de Privacidad
        </Link>
      </div>
    </footer>
  );
};
